<template>
  <div>
    <div v-if='line'>
      <v-progress-linear indeterminate :color='color' :height='width'></v-progress-linear>
    </div>
    <div v-else>
      <v-progress-circular indeterminate :color='color' :width='width' :size='size'></v-progress-circular>
    </div>
    <span class='grey--text'>{{ msg }}{{ message }}</span>
  </div>
</template>

<script>
export default {
  name: 'loading',
  props: {
    message: String,
    msg: String,
    line: {
      required: false,
      type: Boolean,
      default: false
    },
    color: {
      required: false,
      default: 'info'
    },
    width: {
      required: false,
      default: 2
    },
    size: {
      required: false,
      default: 32
    }
  }
}
</script>
